// Basic
import { useState } from 'react';
import PropTypes from 'prop-types';
// Libs
import { cn } from '../../../../../libraries/tailwind/utils';
// Components
import BodySetMails from '../bodies/BodySetMails/BodySetMails';
import HeaderTitle from '../headers/HeaderTitle/HeaderTitle';
import FooterStep from '../footers/FooterStep/FooterStep';
import Entity from '../../../entity/Entity';
import FooterClose from '../footers/FooterClose/FooterClose';
import { Modal, ModalContent } from '../../../../ui/modal';
import Icon from '../../../icon/Icon';
// Common
import ICONS from '@/common-utils/enums/icons';


/**
 * @param root0
 * @param root0.isOpen
 * @param root0.setIsOpen
 * @param root0.onValidate
 * @param root0.isLoading
 * @param root0.header
 * @param root0.message
 * @param root0.confirm
 * @param root0.renderList
 * @param root0.setRenderList
 * @param root0.maxEmailsNumber
 * @param root0.existingEmails
 * @param root0.blockedAction
 * @param root0.isBlocked
 * @param root0.linkValidity
 * @returns {JSX.Element} ModalSendMail
*/
function ModalSendMail({
    isOpen,
    setIsOpen,
    isBlocked = false,
    blockedAction,
    onValidate,
    isLoading,
    header,
    message,
    confirm,
    linkValidity = null,
    renderList,
    setRenderList,
    maxEmailsNumber = 5,
    existingEmails
}) {

    // State
    const [step, setStep] = useState(0);
    const [disableAction, setDisableAction] = useState(true);

    // Constants
    const STEPS_NUMBER = 2;

    return (
        <Modal open={isOpen} onOpenChange={setIsOpen}>
            <ModalContent className={cn('max-w-2xl')}>
                <HeaderTitle title={header.title} namespace={header.namespace} />
                {isBlocked &&
                    <>
                        <div className='flex justify-center space-x-2 p-4'>
                            <Icon
                                icon={ICONS.WARNING}
                                className='text-warning'
                                size={22}
                            />
                            <Entity
                                className='text-base text-center font-semibold whitespace-pre-line'
                                entity={blockedAction.message}
                                namespace={blockedAction.namespace}
                                data={blockedAction.data}
                            />
                        </div>
                        <FooterClose />
                    </>
                }
                {!isBlocked &&
                    <>
                        <BodySetMails
                            step={step}
                            message={message}
                            confirm={confirm}
                            renderList={renderList}
                            setRenderList={setRenderList}
                            disableAction={disableAction}
                            setDisableAction={setDisableAction}
                            maxEmailsNumber={maxEmailsNumber}
                            existingEmails={existingEmails}
                            linkValidity={linkValidity}
                        />
                        <FooterStep
                            step={step}
                            setStep={setStep}
                            stepsNumber={STEPS_NUMBER}
                            onValidate={onValidate}
                            isLoading={isLoading}
                            disableValidation={disableAction}
                        />
                    </>
                }
            </ModalContent>
        </Modal>
    );
}

ModalSendMail.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    setIsOpen: PropTypes.func.isRequired,
    isBlocked: PropTypes.bool,
    blockedAction: PropTypes.shape({
        isBlocked: PropTypes.bool,
        message: PropTypes.string,
        namespace: PropTypes.string
    }),
    header: PropTypes.object,
    message: PropTypes.object,
    confirm: PropTypes.object,
    linkValidity: PropTypes.object,
    onValidate: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    title: PropTypes.string,
    namespace: PropTypes.string,
    renderList: PropTypes.array,
    setRenderList: PropTypes.func,
    maxEmailsNumber: PropTypes.number,
    existingEmails: PropTypes.array
};

export default ModalSendMail;